
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "open_fracture_gustilo",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/open_fracture_gustilo.vue